import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconEditComponent } from "./med-icon-edit.component";

@NgModule({
  declarations: [
    MedIconEditComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconEditComponent,
  ],
})
export class MedIconEditModule { }
